import * as jQuery from "jquery";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { fromOthersNodeName } from "motw_core/Repositories/WorkflowRepository";
import { Emotions } from "source/app/domain/Emotions/Emotions";
import { ToggleUseAnopenscrollFontAsync } from "source/app/services/UI/Fonts/FontPreference";
import { HandleEmotionSelectedLocallyAsync } from "source/app/presentation/BottomBar/EmotionSelector/HandleEmotionSelected/HandleEmotionSelected";
import { ToggleQuickJournal } from "source/app/presentation/BottomBar/QuickJournalToggle/ToggleQuickJournal/ToggleQuickJournal";
import { ChangeStackDifficulty } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/StacksContainer/AdjustStackDifficulty";
import { BookOfMind } from "source/app/presentation/MainPanel/Workflows/BookOfMind/BookOfMind";
import { CompleteAllTodayNodesAsync } from "source/app/presentation/MainPanel/Workflows/RenderChildNodes/ChildNodeName/CompleteNode/Helpers/CompleteAllTodayNodes";
import { LoadPanel } from "source/app/presentation/Shared/ActivePanel/Helpers/LoadPanel";
import { EPanelId } from "source/app/services/Shared/EPanelId";
import SoundManager from "source/app/services/Sound/SoundManager";
import { HandleSelectRandomItemHotkey } from "source/app/services/UI/KeyboardEvents/Global/Helpers/HandleSelectRandomItemHotkey";
import {
    IKeyboardEvent,
    TKeyboardEvent,
} from "source/app/services/UI/KeyboardEvents/IKeyboardEvents";
import {
    IncreaseEnergy,
    ReduceEnergy,
} from "./Dreams/ChangeEnergyKeyboardEvent";
import {
    IncreaseTreeBranch,
    ReduceTreeBranch,
} from "./Dreams/ChangeTreeBranchKeyboardEvents";
import { HandleCreateNewItemHotkey } from "./Helpers/HandleCreateNewItemHotkey";

const SelectRandomItem: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + r`,
    actionDescription: `Select Random Item`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 82,
    action: () => HandleSelectRandomItemHotkey(),
};

const CreateNewItem: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + n`,
    actionDescription: `Create New Item`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 78,
    action: () => HandleCreateNewItemHotkey(),
};

const LoadCalendar: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + c`,
    actionDescription: `Go to Enemies To Face`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 67,
    action: () => LoadPanel(EPanelId.Calendar),
};

const LoadMonumentalAchievements: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + m`,
    actionDescription: `Go to Halls Of Glory`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 77,
    action: () => LoadPanel(EPanelId.LogMonumental),
};

const LoadLifeChangingAcheivements: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + l`,
    actionDescription: `Go to Life Changing Achievements`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 76,
    action: () => LoadPanel(EPanelId.LifeChangingEvents),
};

const LoadDreams: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + d`,
    actionDescription: `Go to New Journeys`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 68,
    action: () => LoadPanel(EPanelId.Dreams),
};

const LoadHeroPanel: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + h`,
    actionDescription: `Go to Hero's Map`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 72,
    action: () => LoadPanel(EPanelId.Hero),
};

const LoadWeather: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + [`,
    actionDescription: `Go to Weather`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 219,
    action: () => LoadPanel(EPanelId.Weather),
};

const LoadUnderDevelopment: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + u`,
    actionDescription: `Go to Under Development`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 85,
    action: () => LoadPanel(EPanelId.UnderDevelopment),
};

const CICOEntry: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + F`,
    actionDescription: `F Key Modifier`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && !event.shiftKey && event.keyCode == 70,
    conditions: [
        {
            when: EPanelId.Hero,
            do: () => {
                jQuery(
                    `#clickTarget_input_${
                        ESharedFunction[ESharedFunction.CICO_calories]
                    }`
                ).focus();
            },
        },
    ],
};

const ToggleFont: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + Shift + F`,
    actionDescription: `Toggle font`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.shiftKey && event.keyCode == 70,
    action: () => ToggleUseAnopenscrollFontAsync(),
};

const LoadWorkflows: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + w`,
    actionDescription: `Go to Library`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 87,
    action: () => LoadPanel(EPanelId.Workflows),
};

const CompleteAllTodayNodes: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + S`,
    actionDescription: `Complete all Today nodes`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 83,
    action: () => CompleteAllTodayNodesAsync(),
};

const LoadHabits: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + G`,
    actionDescription: `Go to Habits`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 71,
    action: () => LoadPanel(EPanelId.Habits),
};

const ToggleQuickJournalHotkey: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + F2`,
    actionDescription: `Toggle quick journal`,
    trigger: (event: TKeyboardEvent) => event.ctrlKey && event.keyCode == 113,
    action: () => ToggleQuickJournal(),
};

const OpenBookOfMind: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + F6`,
    actionDescription: `Open Book of Mind`,
    trigger: (event: TKeyboardEvent) => event.ctrlKey && event.keyCode == 117,
    action: () => BookOfMind(fromOthersNodeName),
};

const SelectPreviousEmotion: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + F7`,
    actionDescription: `Select Previous Emotion`,
    trigger: (event: TKeyboardEvent) => event.ctrlKey && event.keyCode == 118,
    action: () => HandleEmotionSelectedLocallyAsync(Emotions.Current.Previous),
};

const SelectCurrentEmotion: IKeyboardEvent = {
    hotkeyDescription: `Alt + F8`,
    actionDescription: `Select Current Emotion`,
    trigger: (event: TKeyboardEvent) => event.altKey && event.keyCode == 119,
    action: () => HandleEmotionSelectedLocallyAsync(Emotions.Current),
};

const SelectNextEmotion: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + F8`,
    actionDescription: `Select Next Emotion`,
    trigger: (event: TKeyboardEvent) => event.ctrlKey && event.keyCode == 119,
    action: () => HandleEmotionSelectedLocallyAsync(Emotions.Current.Next),
};

const ToggleSound: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + Q`,
    actionDescription: `Toggle Environment`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 81,
    action: () => SoundManager.ToggleEnvironment(),
};

const ToggleMute: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + Shift + M`,
    actionDescription: `Toggle Mute`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.shiftKey && event.keyCode == 77,
    action: () => SoundManager.ToggleMute(),
};

const IncreaseStackDifficulty: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + .`,
    actionDescription: `Increase stack difficulty`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 190,
    conditions: [
        {
            when: EPanelId.Hero,
            do: () => ChangeStackDifficulty(1),
        },
    ],
};

const DecreaseStackDifficulty: IKeyboardEvent = {
    hotkeyDescription: `Ctrl + Alt + ,`,
    actionDescription: `Decrease stack difficulty`,
    trigger: (event: TKeyboardEvent) =>
        event.ctrlKey && event.altKey && event.keyCode == 188,
    conditions: [
        {
            when: EPanelId.Hero,
            do: () => ChangeStackDifficulty(-1),
        },
    ],
};

export const globalKeyboardEvents: IKeyboardEvent[] = [
    SelectRandomItem,
    CreateNewItem,
    LoadCalendar,
    LoadDreams,
    LoadHeroPanel,
    LoadWeather,
    LoadUnderDevelopment,
    CICOEntry,
    LoadMonumentalAchievements,
    LoadLifeChangingAcheivements,
    LoadWorkflows,
    CompleteAllTodayNodes,
    LoadHabits,
    ToggleQuickJournalHotkey,
    OpenBookOfMind,
    SelectPreviousEmotion,
    SelectNextEmotion,
    SelectCurrentEmotion,
    ToggleSound,
    ToggleMute,
    ToggleFont,
    IncreaseStackDifficulty,
    DecreaseStackDifficulty,
    IncreaseEnergy,
    ReduceEnergy,
    IncreaseTreeBranch,
    ReduceTreeBranch,
];
